import Navbar from '../../components/Navbar'
import Hero from './components/Hero'
import StatsBar from './components/StatsBar'
import Features from './components/Features'
import Executives from './components/Executives'
import CallToAction from './components/CallToAction'
import Footer from '../../components/Footer'

export default function Home() {
  return (
    <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col">
      <Navbar />
      <Hero />
      <StatsBar />
      <Features />
      <Executives />
      <CallToAction />
      <Footer />
    </div>
  )
}